import script from "./ViewDatehandler.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewDatehandler.vue?vue&type=script&setup=true&lang=js"

import "./ViewDatehandler.vue?vue&type=style&index=0&id=552d4d8c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-552d4d8c"]])

export default __exports__